jQuery(function ($) {
	$( '#fileupload ').fileupload({
		maxNumberOfFiles: 5,
		acceptFileTypes: /(\.|\/)(gif|jpe?g|png)$/i,
		dataType:  'json ',
		sequentialUploads: false,
		add: function (e, data) {
			var fn = data.files[0].name;
			var rg = /^[0-9a-zA-Z\_\-\.]+$/
			if (fn) {
				if (!rg.test(fn)) {
					$('#rejected_photos_row',parent.document).show();
					$("#filename-warning",parent.document).modal("show");
					$('#rejected_photos',parent.document).append($('<div class="col-12 col-sm-6 col-md-4 col-lg-3 m-3 p-2 bg-white border border-danger rounded text-center text-danger"><b>' + fn + '</b></div>'));
				}
				else {
					$('#submit_pet', window.parent.document).attr('disabled', 'disabled');
					$('#photo_wait_msg', window.parent.document).show();
					$('#time_display', window.parent.document).show();
					$("#upload_count",parent.document).val(parseInt($("#upload_count",parent.document).val())+1);
					data.context = $('#photo_prototype',parent.document).clone().removeAttr('id').show().appendTo($('#results', window.parent.document));
					data.context.find('.file_name').text(fn)
					data.submit();
				}
			}
		},
		done: function (e, data) {
			//console.log(data);
			$.each(data.result.files, function (index, file) {
				//console.log(file);
				$("#upload_count",parent.document).val(parseInt($("#upload_count",parent.document).val())-1);
				if ($("#upload_count",parent.document).val() <= 0) {
					$('#submit_pet', window.parent.document).removeAttr('disabled');
					$('#photo_wait_msg', window.parent.document).hide();
				}
				if (file.error) {
					data.context.find('.err_msg').text('Error: (' + file.name + ') ' + file.error).addClass('file_error');
					data.context.find('> div').hide();
					data.context.find('.error').show();
					setTimeout(function() {
						data.context.hide("slow", function(){
							data.context.remove();
						});
					}, 3000);
				} else {
					$("#highlight_check", parent.document).attr('required','required');
					var photo = data.context;
					photo.find('.uploading').hide();
					photo.find('.uploaded').show();
					photo.attr('id', 'list_' + file.id);
					photo.find('a').attr('href', file.url).find('img').attr('id','image_' + file.id + '_img').attr('src', file.thumbnailUrl);
					photo.find('.photo_id_input').val(file.id).attr('id', 'photo_' + file.id + '_input');
					photo.find('.highlight_radio').val(file.id).attr('id', 'photo_' + file.id + '_highlight_input');
					photo.find('.highlight-label').attr('for','photo_' + file.id + '_highlight_input');
					photo.find('.delete').attr('data-type', file.deleteType).attr('data-url',file.deleteUrl);
					if ( $('.highlight_radio',parent.document).is(":checked")) {
					} else {
						photo.find('.highlight-label').click();
					}
					photo.appendTo(data.context);
					top.init_pp();
				}
			});
			$('#time_display', window.parent.document).hide();
			$('#progress .progress-bar',window.parent.document).html('');
			$('#progress .progress-bar',window.parent.document).css('width','0% ');
		},
		progressall: function (e, data) {
			var progress = parseInt(data.loaded / data.total * 100, 10);
			var time_remaining =  (data.total - data.loaded) * 8 / data.bitrate;
			time_remaining =	formatTime(time_remaining);
			$('#time_remaining',window.parent.document).text(time_remaining);
			$('#progress .progress-bar',window.parent.document).html('<span>' + progress + '%</span>');
			$('#progress .progress-bar',window.parent.document).css('width',progress + '% ');
		}
	});


	function formatTime(seconds) {
		var date = new Date(seconds * 1000),
			days = Math.floor(seconds / 86400);
		days = days ? days + 'd ' : '';
		return days +
			('0' + date.getUTCHours()).slice(-2) + ':' +
			('0' + date.getUTCMinutes()).slice(-2) + ':' +
			('0' + date.getUTCSeconds()).slice(-2);
   }
});